import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />, 'Pause');
